// extracted by mini-css-extract-plugin
export default {"delete_topic__btn":"styles_delete_topic__btn__XFo92"};